import { createStore } from 'vuex'
import API from '@/api/index.js'

import { new_comments, commentHasContentStructure } from '@/utils/kyc_utils.js'
import Utils from '@/utils/index.js'


function copy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

const metaFieldsFile = [
  'dateIssued', 'fiscal_year_ending_on', 'year', 'bank_name',
  'pep_found',
  'relevant_adverse_information_found',
  'sanctions_found',
  'pep_found_supervisor',
  'sanctions_found_supervisor',
  'relevant_adverse_information_found_supervisor',
  'pep_found_compliance',
  'sanctions_found_compliance',
  'relevant_adverse_information_found_compliance',
  'expiration_date',
  'certDate',
  'certNotification',
  'license_type',
]

const commentsPerson = [
  'client_comment',
  'comment_data_handler', 
  'comment_compliance_officer', 
  'comment_supervisor',
  'sanctions_comment',
  'pep_comment',
  'relevant_adverse_information_comment',
  'sanctions_comment_supervisor',
  'pep_comment_supervisor',
  'relevant_adverse_information_comment_supervisor',
  'sanctions_comment_compliance',
  'pep_comment_compliance',
  'relevant_adverse_information_comment_compliance',
]

let mdFields = ['entity_type', 'location_type'];
let personFields = [
  'location_type',
  'percentage_held',
  'title',
  'placeofBirth',
  'firstName',
  'lastName',
  'tinNumber',
  'passportNumber',
  'passportCountry',
  'dateIssued',
  'dateExpiry',
  'dateOfBirth',
  'secondPassportType',
  'secondPassportNumber',
  'secondPassportCountry',
  'secondDateIssued',
  'secondDateExpiry',
  'address_line_1',
  'address_line_2',
  'address_date_issues',
  'city',
  'address_country',
  'zip'
];

let entityFields = [
  'supervised',
  'name',
  'address_line_1',
  'address_line_2',
  'city',
  'address_country',
  'zip',
]

let fieldsTransaction = [
  'name_bank',
  'currency',
  'transaction_value_incoming',
  'monthly_turnover_incoming',
  'monthly_frequency_of_transaction_incoming',
  'transaction_value_outgoing',
  'monthly_turnover_outgoing',
  'monthly_frequency_of_transaction_outgoing',
  'outgoing_counterparty',
  'outgoing_counterparty_2',
  'outgoing_counterparty_3',
  'incoming_counterparty',
  'incoming_counterparty_2',
  'incoming_counterparty_3',
]
const commentsTransaction = [
  'comments',
  'expected_transaction_incoming_info',
  'expected_transaction_outgoing_info',
]

export default createStore({
  state: {
    userPermissions: null,
    user: null,
    isMobile: false,
    userAddress: null,
    userPhone: null,
    userInformation: null,
    licenceElem: null,
    clientAccount: null,
    agreements: [],
    animationPassed: false,
    selectedTemplateId: null,
    adminPannelUser: null,
    fiuTemplates: null,
    loaded: false,
    notificationsCount: null,
    validationOn: false,
    credits_balance: null,
    response_text: null,
    notifications: [],
    sanctionScreeningRequestLoading: false,
    labelYear: null,
    roles: null,
    objectMap: null,
    pendingAgreements: null,
    approvedActions: 2,
    colapsedSections: {},
    confirmationNeeded: null,
    selectedSnapshot: null,
    kycDataLoaded: false,
    dataStructureStore: null,
    companyData: null,
    commentSection: null,
    commentSectionInitial: null,
    banks: null,
    savingData: false,
    proposedChanges: null,
    editDueDiligence: false,
    currentSectionId: null,
    kyc_files: [],
    kyc_ubos: [],
    kyc_entities: [],
    kyc_mds: [],
    kyc_persons: [],
    kyc_accountNumbers: [],
    kyc_transactionalProfile: [],
    kyc_shareholders: [],
    listingServices: null,
    subsidiaries: null,
    dueDiligenceElements: [],
    dueDiligenceRecord: null,
    dueDiligenceFiles: null,
    yearOptions: [
      {value: '2021', text: '2021'},
      {value: '2022', text: '2022'},
      {value: '2023', text: '2023'},
      {value: '2024', text: '2024'},
      {value: '2025', text: '2025'},
      {value: '2026', text: '2026'},
      {value: '2027', text: '2027'},
      {value: '2028', text: '2028'},
      {value: '2029', text: '2029'},
      {value: '2030', text: '2030'},
      {value: '2031', text: '2031'},
      {value: '2032', text: '2032'},
      {value: '2033', text: '2033'},
      {value: '2034', text: '2034'},
      {value: '2036', text: '2036'},
      {value: '2037', text: '2037'},
    ],

    corporateStructure: [],

    accounts: null,
    viewingToken: null,
    fileList: null,
    wallet: {
      loaded: false,
      address: null,
    },
    sidebarCollapsed: (() => { try { return localStorage.getItem('sidebarCollapsed') === '1'; } catch (e) { return false; } })(),
  },
  getters: {
    FIU_Available: state => state.clientAccount.fiu_section_available,
    KYC_Available: state => state.clientAccount.kyc_section_available,
    DD_Available: state => state.clientAccount.due_diligence_section_available,
    SS_Available: state => state.clientAccount.sanctions_screening_section_available,

    getFileId: state => (documentType) => {
      let file = state.kyc_files.find(f => f.documentType === documentType);
      console.log('getFileId', file, documentType)
      if (file) {
        return file.id;
      }
    },
    getFilesId: state => (documentType) => {
      
      let files = state.kyc_files.filter(f => f.documentType === documentType);
      let ids = [];
      if (files) {
        files.forEach(f => {
          ids.push(f.id);
        });
      }
      return ids;
    },
    getFileById: state => (file_id) => {
      if( !file_id ) {
        return
      }
      let fileId = file_id?.value;
      if (!fileId) {
        fileId = file_id;
      }
      return state.kyc_files.find(f => f.id === fileId);
    },
    getFilesMapID: state => {
      let filesMap = {};
      state.kyc_files.forEach(f => {
        filesMap[f.id] = f;
      })
      return filesMap;
    },
    getWorldCheckEditablePrefix: state => {
      let accountTypeMap = {
        'DATA_CONTROLLER': '',
        'DATA_PROCESSOR': '_supervisor',
        'COMPLIANCE_OFFICER': '_compliance',
      }
      console.log('getWorldCheckEditablePrefix', state.user.type, accountTypeMap[state.user.type])
      return accountTypeMap[state.user.type];
    },
    
    getCompanyType: state => {
      if (!state.companyData) {
        return null;
      }
      return state.companyData.location_type.new_value || state.companyData.location_type.value;
    },
    getActionRequired: state => (id, objectType) => {
      let objId = id?.value || id;
      if (!state.confirmationNeeded) {
        return [];
      }
      let confirmationNeeded = state.confirmationNeeded.filter( obj => obj.objectType === objectType && obj[objectType] === objId);
      return confirmationNeeded;
    },
    getCorporateFilesOptions: state => {
      let corporateFiles = state.kyc_files.filter( file => !file.person && !file.legalEntity && !file.mbd_related && !file.ubo_related);
      let corporateFilesOptions = [];
      corporateFiles.forEach( file => {
        let text = Utils.typeToName(file.documentType);
        if (['scfba', 'cosbaof'].includes(file.documentType)) {
          text = `${Utils.typeToName(file.documentType)} for ${file.bank_name || ''}`
        }
        if (file.documentType === 'subsidiaries') {
          let subsidiary = state.subsidiaries.find(sub => sub._id === file.subsidiary_id);
          text = `${Utils.typeToName(file.documentType)} for ${subsidiary?.name || ''}`          
        }
        corporateFilesOptions.push({value: file.id, text: text});
      });
      return corporateFilesOptions;
    },

    getSectionFilesOptions: state => (element_id, type) => {
      let options = [];
      let element = null;
      let element_files = {}
      if (type == 'individual') {
        element = state.kyc_persons.find(p => p._id === element_id);
        if (!element) {
          console.log('getIndividualFilesOptions', element_id, 'not found')
          return options;
        }
        element_files = element.files;
        if (element.location_type.value === 'local') {
          delete element_files['secondPassport'];
        }
        if (element.mbd_related) {
          delete element_files['source_of_funds'];
          delete element_files['source_of_wealth'];
        }

      } else if (type == 'entity') {
        element = state.kyc_entities.find(e => e._id === element_id);
        if (!element) {
          console.log('getIndividualFilesOptions', element_id, 'not found')
          return options;
        }
        element_files = element.files;
        if (element.share_holder_related) {
          delete element_files['entity_license'];
        }
      }
     
      Object.keys(element_files).forEach(f => {
        let file = state.kyc_files.find(file => file.id === element_files[f]);
        if (file) {
          let text = Utils.typeToName(file.documentType);
          options.push({value: file.id, text: text});
        }
      });
      console.log('getIndividualFilesOptions', element_id, options)
      return options;
    },

    getPersonOptions: state => {
      let filesOptions = [];
      state.kyc_persons.forEach( person => {
        let text = person.firstName.value + ' ' + person.lastName.value;
        let skip = false
        if (text == ' ') {
          skip = true
        }

        if (person.ubo_related) {
          text = text + ' (UBO)';
        } else if (person.mbd_related) {
          text = text + ' (Official)';
        }
        if (!skip) {
          filesOptions.push({value: person._id, text: text});
        }
      });
      filesOptions.sort((a, b) => a.text.localeCompare(b.text));
      return filesOptions;
    },
    getEntityOptions: state => {
      let filesOptions = [];
      state.kyc_entities.forEach( entity => {
        let text = entity.name.value;
        let skip = false
        if (!text) {
          skip = true
        }
        if (entity.share_holder_related) {
          text = text + ' (Shareholder)';
        } else if (entity.mbd_related) {
          text = text + ' (Managing Director)';
        }
        if (!skip) {
          filesOptions.push({value: entity._id, text: text});
        }
      });
      filesOptions.sort((a, b) => a.text.localeCompare(b.text));
      return filesOptions;
    },
    getCorporateFilesReadiness: state => {
      return state.kyc_files.filter( file => !file.person && !file.legalEntity && !file.mbd_related && !file.ubo_related)
    },
    
    getFiles: state => (documentType) => {
      return state.kyc_files.filter(f => f.documentType === documentType);
    },
    getCorporateUbo: state => {
      return state.kyc_ubos.filter(ubo => !ubo.mbd_related);
    },
    shareholders: state => (md_id = null) => {
      return state.kyc_shareholders.filter(shareholder => shareholder.mbd_related == md_id);
    },
    getUboById: state => (ubo_id) => {
      return state.kyc_ubos.find(ubo => ubo._id === ubo_id);
    },
    getPersonOfUboById: state => (ubo_id) => {
      return state.kyc_persons.find(person => person.ubo_related === ubo_id);
    },
    getPersonById: state => (person_id) => {
      return state.kyc_persons.find(person => person._id === person_id);
    },
    managingDirectors: state => (share_holder_related = null, mbd_related = null) => {
      return state.kyc_mds.filter(md => md.share_holder_related == share_holder_related && md.mbd_related == mbd_related);
    },
    getMdById: state => (md_id) => {
      return state.kyc_mds.find(md => md._id === md_id);
    },
    checkmarksConform: state => (file_id) => {
      let userType = state.user.type;
      let same = true
      let file = state.kyc_files.find(f => f.id === file_id);
      if (!file) {
        return false
      }
      if (file.documentType !== 'world_check') {
        return true
      }
      if (userType == 'DATA_CONTROLLER') {
        return true
      }
      let pep_found = file?.new_pep_found || file?.pep_found;
      let sanctions_found = file?.new_sanctions_found || file?.sanctions_found;
      let relevant_adverse_information_found = file?.new_relevant_adverse_information_found || file?.relevant_adverse_information_found
      
      let pep_found_supervisor = file?.new_pep_found_supervisor || file?.pep_found_supervisor
      let sanctions_found_supervisor = file?.new_sanctions_found_supervisor || file?.sanctions_found_supervisor
      let relevant_adverse_information_found_supervisor = file?.new_relevant_adverse_information_found_supervisor || file?.relevant_adverse_information_found_supervisor

      let pep_found_compliance = file?.new_pep_found_compliance || file?.pep_found_compliance
      let sanctions_found_compliance = file?.new_sanctions_found_compliance || file?.sanctions_found_compliance
      let relevant_adverse_information_found_compliance = file?.new_relevant_adverse_information_found_compliance || file?.relevant_adverse_information_found_compliance

      if (['DATA_PROCESSOR','COMPLIANCE_OFFICER'].includes(userType)) {
        same = (
          pep_found_supervisor == pep_found &&
          sanctions_found_supervisor == sanctions_found &&
          relevant_adverse_information_found_supervisor == relevant_adverse_information_found
        )
      }
      if (userType == 'COMPLIANCE_OFFICER') {

        same = same && (
          pep_found_compliance == pep_found &&
          sanctions_found_compliance == sanctions_found &&
          relevant_adverse_information_found_compliance == relevant_adverse_information_found
        )
      }
      return same
    },
    getOfficialsOfMd: state => (md_id) => {
      return state.kyc_persons.filter(person => person.mbd_related === md_id && !person.ubo_related);
    },
    getEntityOfMD: state => (md_id) => {
      return state.kyc_entities.find(entity => entity.mbd_related === md_id);
    },
    getEntityById: state => (entity_id) => {
      return state.kyc_entities.find(entity => entity._id === entity_id);
    },
    UBOs: state => (share_holder_related) => {
      return state.kyc_ubos.filter(ubo => ubo.share_holder_related === share_holder_related);
    },
    getMdUBOs: state => (md_id) => {
      return state.kyc_ubos.filter(ubo => ubo.mbd_related === md_id);
    },
    getSubsidiaryById: state => (subsidiary_id) => {
      if (state.subsidiaries === null) {
        return null;
      }
      return state.subsidiaries.find(subsidiary => subsidiary._id === subsidiary_id);
    },
    getTransactionRevewialProfileById: state => (id) => {
      return state.kyc_transactionalProfile.find(trans_prof => trans_prof._id === id);
    },
    getAccountNumberById: state => (id) => {
      return state.kyc_accountNumbers.find(account => account._id === id);
    },
    getShareholderMDs: state => (md_id) => {
      return state.kyc_mds.filter(md => md.mbd_related === md_id);
    },
    getToggleState: state => (id) => {
      if (state.colapsedSections[id] != undefined) {
        return state.colapsedSections[id];
      }
      return true;
    },
    getShareHolderById: state => (id) => {
      return state.kyc_shareholders.find(shareholder => shareholder._id === id);
    },
    getUboofShareholderById: state => (id) => {
      return state.kyc_ubos.find(ubo => ubo.share_holder_related === id);
    },
    getMDofShareholderById: state => (id) => {
      return state.kyc_mds.find(md => md.share_holder_related === id);
    },
    needToSave: state => {
   
      if (!state.kyc_mds) {
        return false
      }
      for(let md of state.kyc_mds) {
        for (let field of mdFields) {
          let newValue = md[field]?.new_value?.trim ? md[field].new_value.trim() : md[field].new_value;
          if (newValue !== md[field].value && newValue != undefined && newValue !== null) {
            return true;
          }
        }
      }
      for (let person of state.kyc_persons) {
        for (let key of personFields) {
          let newValue = person[key]?.new_value?.trim ? person[key].new_value.trim() : person[key].new_value;
          if (newValue !== person[key].value && newValue != undefined && newValue !== null) {
            return true;
          }
        }
      }
      for (let entity of state.kyc_entities) {
        for (let key of entityFields) {
          let newValue = entity[key]?.new_value?.trim ? entity[key].new_value.trim() : entity[key].new_value;
          if (
              newValue != undefined &&
              newValue !== entity[key].value
            ) {
              return true;
          }
        }
      }
      for (let file of state.kyc_files) {
        const ObjectToSend = {}
        let attachedFile = null
        const newFIleUploaded = file.new_file;
        if (newFIleUploaded) {
          attachedFile = file.file
        }
        for (let field of metaFieldsFile) {
          if (file['new_' + field] && file['new_' + field].trim() !== file[field]) {
            ObjectToSend[field] = file['new_' + field]
          }
        }
        for (let field of commentsPerson) {
          if (new_comments(file, field)) {
            ObjectToSend[field] = JSON.stringify(file['new_' + field])
          }
        }

        if (attachedFile || Object.keys(ObjectToSend).length > 0) {
          return true;
        }
      }
      for (let accountNumber of state.kyc_accountNumbers) {
        let fields = [
          'account_number',
        ]
        for (let field of fields) {
          let newValue = accountNumber[field]?.new_value?.trim ? accountNumber[field].new_value.trim() : accountNumber[field].new_value;
          if (
            (newValue !== accountNumber[field].value) 
            && newValue != undefined && newValue !== null) {
            return true;
          }
        }
      }
      for (let transactionProfile of state.kyc_transactionalProfile) {
        for (let field of fieldsTransaction) {
          let newValue = transactionProfile[field]?.new_value?.trim ? transactionProfile[field].new_value.trim() : transactionProfile[field].new_value;
          if (newValue !== transactionProfile[field].value  && newValue != undefined && newValue !== null) {
            console.log('transactionProfile', field, newValue, transactionProfile[field].value)
            return true;
          }
        }
        for (let field of commentsTransaction) {
          let result = new_comments(transactionProfile, field, 'new');
          if (result) {
            return true;
          }
        }
      }
      for (let shareholder of state.kyc_shareholders) {
        let fields = [
          'percentage_held',
          'shareholder_type',
        ]
        for (let field of fields) {
          if (shareholder[field].new_value !== shareholder[field].value && shareholder[field].new_value) {
            return true;
          }
        }
      }
      {
        for (let key in state.companyData) {
          if (['_id', 'company_type'].includes(key)) {
            continue
          }
          let newValue = state.companyData[key]?.new_value?.trim ? state.companyData[key].new_value.trim() : state.companyData[key].new_value;
          if (
              newValue !== state.companyData[key].value
              && newValue != undefined 
              && newValue !== null
            ) {
              console.log('companyData', key, newValue, state.companyData[key].value)
            return true;
          }
        }
      }
      if (state.listingServices?.new_value && state.listingServices?.new_value !== state.listingServices?.value) {
        return true;
      }
      return false
    },
    getStructureForChart: (state, getters)  => ({ id, type, source = 'shareholder', root = false, shareholder_id, mbd_id, full = false}) => {
      if (!type) return null;

      if (type === "shareholder") {
        let shareholders = []
        if (shareholder_id) {
          shareholders.push(getters.getShareHolderById(shareholder_id))
        } else {
          shareholders = getters.shareholders(id);

        }
        if (!shareholders) return null;

        const resultShares = shareholders.map(shareholder => {
          let jsShare = copy(shareholder);
          jsShare.type = 'shareholder';
          jsShare.children = [];
          jsShare.percentage_held = jsShare.percentage_held.new_value || jsShare.percentage_held.value;
          jsShare.shareholder_type = shareholder.shareholder_type.new_value || shareholder.shareholder_type.value;
          if (jsShare.shareholder_type === 'person') {
            let ubo = getters.getUboofShareholderById(shareholder._id);
            let person = getters.getPersonOfUboById(ubo._id);
            let person_copy = copy(person);
            let element = {
              _id: person_copy._id,
              name: `${person_copy.firstName.value} ${person_copy.lastName.value}`,
              type: 'ubo',
            }
            if (full) {
              element = {
                ...person_copy,
                type: 'ubo',
              };
            }

            jsShare.children.push(element);
            return jsShare

          } else {
            // always a single one for shareholder (there can only be one entity inside a shareholder)
            let md = getters.getMDofShareholderById(shareholder._id);
            let shareholderResults = getters.getStructureForChart({ id: md._id, type: "entity", source: 'shareholder', mbd_id: md._id, full })
            
            return {
              ...jsShare,
              children: shareholderResults
            };
          } 
        })

        if (root) {
          if (!id) {
            let mds = getters.getStructureForChart({ id: id, type: "entity", source: 'entity', full })
            let resutl = [{
              name: state.companyData.name.value,
              type: 'main_for_sh',
              children: [...resultShares],
              someOtherStuff: mds
            }]
            return resutl
          }
        }
        return resultShares

      } else if (type === "entity") {
        let mdsResult = [];
        if (mbd_id) {
          mdsResult.push(getters.getMdById(mbd_id))
        } else  {
          mdsResult = getters.managingDirectors(id);
        }

        if (!mdsResult) return null;

        let resMDs = mdsResult.map(md => {
          let jsMD = copy(md);
          jsMD.type = source == 'shareholder' ? 'corporate_shareholder' : 'corporate';
          jsMD.children = [];
          jsMD.entity_type = jsMD.entity_type.new_value || jsMD.entity_type.value;
          let entity = getters.getEntityOfMD(jsMD._id);
          md.name = entity.name.value;
          jsMD.supervised = entity.supervised.value;
          
          if (full) {
            jsMD.entity = entity;
          }

          let officials = getters.getOfficialsOfMd(jsMD._id);
          for (let official of officials) {
            let copyOfficial = copy(official);
            if (full) {
              jsMD.children.push({
                type: 'official',
                ...copyOfficial
              });
            } else {
              jsMD.children.push({
                type: 'official',
                name: `${copyOfficial.firstName.value} ${copyOfficial.lastName.value}`,
              });
            }
          }
          getters.shareholders(jsMD._id).forEach(shareholderEl => {
            jsMD.children.push(...getters.getStructureForChart({ id: md._id, shareholder_id: shareholderEl._id, type: "shareholder", source: 'entity', full }))
          })
          getters.getShareholderMDs(jsMD._id).forEach(mdel => {
            jsMD.children.push(...getters.getStructureForChart({ id: mdel._id, type: "entity", source: 'entity', mbd_id: mdel._id, full }))
          })
          return jsMD
        })

        if (root) {
          if (!id) {

            const result = [{
              name: state.companyData.name.value,
              type: 'main_for_md',
              children: resMDs,
            }]
            return result
          }
        }
        return resMDs;
      }
    },
    missingFieldsFIUAgreement: state => {
      if (!state.userInformation) {
        return null;
      }
    },
    missingUserInfoFields: state => {
      if (!state.userInformation) {
        return null;
      }
      const missing = [];
      let fields = {
        rentity_id: 'Entity ID',
        rentity_branch: 'Entity Branch',
        // title_name: 'Title',
        first_name: 'First Name',
        last_name: 'Last Name',
        email: 'Email',
        gender: 'Gender',
        birth_date: 'Birth Date',
        id_number: 'ID Number',
        nationality: 'Nationality',
        
        local_currency: 'Local Currency',
        // occupation: 'Occupation',
        // passport_number: 'Passport Number',
        // pasport_country: 'Passport Country',
      }
      let phoneFields = {
        phone_type: 'Phone Type',
        communication_type: 'Communication Type',
        phone_prefix: 'Phone Prefix',
        phone_number: 'Phone Number',
      }
      let addressFields = {
        address_type:  'Address Type',
        address: 'Address',
        // town: 'Town',
        city: 'City',
        zip: 'Zip Code',
        country: 'Country',
        // state: 'State',
      }
      let licenceFields = {
        license_number: 'Licence Number',
        issuing_authority: 'Issuing Authority'
      }
      for (const key in fields) {
        if (!state.userInformation[key] || state.userInformation[key].length === 0) {
          missing.push(fields[key]);
        }
      }
      for (const key in addressFields) {
        if (!state.userAddress[key] || state.userAddress[key].length === 0) {
          missing.push(addressFields[key]);
        }
      }
      for (const key in phoneFields) {
        if (!state.userPhone[key] || state.userPhone[key].length === 0) {
          missing.push(phoneFields[key]);
        }
      }
      if (state.selectedTemplateId && state.selectedTemplateId !== 'BANK_ACCOUNT_TRANSFER') {
        for (const key in licenceFields) {
          if (!state.licenceElem[key] || state.licenceElem[key].length === 0) {
            missing.push(licenceFields[key]);
          }
        }
      }
      return missing;
    }
  },
  mutations: {
    setValue(state, {key, value}) {
      state[key] = value;
    },
    toggleSidebar(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed;
      try { localStorage.setItem('sidebarCollapsed', state.sidebarCollapsed ? '1' : '0'); } catch (e) {}
    },
    updateListingServices(state, listingServices) {
      state.listingServices.new_value = listingServices;
    },
    resetListingServices(state, value) {
      state.listingServices.new_value = '',
      state.listingServices.value = value
    },
    addUboObjects(state, uboResponse) {
      state.kyc_files.unshift(...uboResponse.files);
      state.kyc_persons.unshift(uboResponse.person);
      state.kyc_ubos.unshift(uboResponse.ubo);
    },
    addPersonObject(state, officialResponse) {
      state.kyc_files.unshift(...officialResponse.files);
      state.kyc_persons.unshift(officialResponse.person);
    },
    addMDObject(state, mdResponse) {
      state.kyc_files.unshift(...mdResponse.files);
      state.kyc_entities.unshift(mdResponse.entity);
      if (mdResponse.person) {
        state.kyc_persons.unshift(mdResponse.person);
      }
      state.kyc_mds.unshift(mdResponse.md);
    },
    addShareholderObject(state, shareholderResponse) {
      state.kyc_files.unshift(...shareholderResponse.files);
      state.kyc_entities.unshift(shareholderResponse.entity);
      state.kyc_persons.unshift(...shareholderResponse.person);
      state.kyc_mds.unshift(shareholderResponse.md);
      state.kyc_shareholders.unshift(shareholderResponse.shareHolder);
      state.kyc_ubos.unshift(shareholderResponse.ubo);
    },
    addNotification(state, notification) {
      const timeout_dict = {
        'success': 3_000,
        'error': 7_000,
        'warning': 8_000,
      }
      const timeout = timeout_dict[notification.type] || 3_000;
      const id = Math.floor(Math.random() * 1000);
      state.notifications.push({...notification, id});
      setTimeout(() => {
        state.notifications = state.notifications.filter(n => n.id !== id);
      }
      , timeout);
    },
    updateFileById(state, payload) {
      const { id, updates, full = false } = payload;
      
      let fileId = id?.value;
      if (!fileId) {
        fileId = id;
      }
      const itemIndex = state.kyc_files.findIndex(item => item.id === fileId);
      if (itemIndex !== -1) {
        if (full) {
          state.kyc_files[itemIndex] = updates;
        } else {
          state.kyc_files[itemIndex] = { ...state.kyc_files[itemIndex], ...updates };
        }
      }
    },
    updateDueDiligenceElement(state, payload) {
      const { id, updates,  } = payload;
      const itemIndex = state.dueDiligenceElements.findIndex(item => item._id === id);
      if (itemIndex !== -1) {
        for (const key in updates) {
          state.dueDiligenceElements[itemIndex][key].new_value = updates[key];
          if (state.dueDiligenceCheck){
            if (updates[key]) {
              state.dueDiligenceElements[itemIndex][key].error = ''
            }
          } 
        }
      }
    },
    updateDueDiligenceRecord(state, payload) {
      const { updates } = payload;
      console.log('updates', updates);

      for (const key in updates) {
        state.dueDiligenceRecord[key].new_value = updates[key];
        if (state.dueDiligenceCheck){
          if (updates[key]) {
            state.dueDiligenceRecord[key].error = ''
          }
        } 
      }
    },
    updateShareHolderById(state, payload) {
      const { id, updates, full = false } = payload;
      const itemIndex = state.kyc_shareholders.findIndex(item => item._id === id);
      if (itemIndex !== -1) {
        for (const key in updates) {
          if (full) {
            state.kyc_shareholders[itemIndex][key] = updates[key];
          } else {
            state.kyc_shareholders[itemIndex][key].new_value = updates[key];
          }
        }
      }
    },
    updateEntityById(state, payload) {
      const { id, updates, full = false } = payload;
      console.log('updateEntityById', id, updates)
      const itemIndex = state.kyc_entities.findIndex(item => item._id === id);
      if (itemIndex !== -1) {
        for (const key in updates) {
          if (full) {
            console.log('full', key, updates[key])
            state.kyc_entities[itemIndex][key] = updates[key];
          } else {
            state.kyc_entities[itemIndex][key].new_value = updates[key];
          }
        }
      }
    },
    updatePersonById(state, payload) {
      const { id, updates, full = false } = payload;

      const itemIndex = state.kyc_persons.findIndex(item => item._id === id);
      console.log('itemIndex', itemIndex, id)
      if (itemIndex !== -1) {
        for (const key in updates) {
          if (full) {
            state.kyc_persons[itemIndex][key] = updates[key];
          } else {
            state.kyc_persons[itemIndex][key].new_value = updates[key];
          }
        }
      }
    },
    updateManagingDirrectorById(state, payload) {
      const { id, updates, full = false } = payload;

      const itemIndex = state.kyc_mds.findIndex(item => item._id === id);
      if (itemIndex !== -1) {
        for (const key in updates) {
          if (full) {
            state.kyc_mds[itemIndex][key] = updates[key];
          } else {
            state.kyc_mds[itemIndex][key].new_value = updates[key];
          }
        }
      }
    },
    updateAccountNumberById(state, payload) {
      const { id, updates, full = false } = payload;

      const itemIndex = state.kyc_accountNumbers.findIndex(item => item._id === id);
      if (itemIndex !== -1) {
        for (const key in updates) {
          if (full) {
            state.kyc_accountNumbers[itemIndex][key] = updates[key];
          } else {
            state.kyc_accountNumbers[itemIndex][key].new_value = updates[key];
          }
        }
      }
    },
    updateTransactionProfileById(state, payload) {
      const { id, updates, not_new = false, full = false } = payload;
    
      const fieldToUpdate = not_new ? 'value' : 'new_value';

      console.log('updateTransactionProfileById', fieldToUpdate, id, JSON.parse(JSON.stringify(updates)))
      const itemIndex = state.kyc_transactionalProfile.findIndex(item => item._id === id);
      if (itemIndex !== -1) {
        for (const key in updates) {
          if (full) {
            if (key === 'expected_transaction_outgoing_info') {
              console.log('expected_transaction_outgoing_info', updates[key], JSON.parse(JSON.stringify(updates[key])))
            }
            state.kyc_transactionalProfile[itemIndex][key] = JSON.parse(JSON.stringify(updates[key]));
          } else {
            state.kyc_transactionalProfile[itemIndex][key][fieldToUpdate] = updates[key];
          }
        }
      }
    },
    updateKycReviewInfo(state, payload) {
      const {updates, full = false} = payload;
      console.log('updateKycReviewInfo', updates)
      for (const key in updates) {
        if (full) {
          state.companyData[key] = updates[key];
        } else {
          state.companyData[key].new_value = updates[key];
        }
      }
    },
    addAccountNumberMutations(state, accountNumber) {
      state.kyc_accountNumbers.push(accountNumber);
    },
    addTransactionProfileMutations(state, transactionProfile) {
      state.kyc_transactionalProfile.push(transactionProfile);
    }
  },
  actions: {
    setValue({ commit }, newValue) {
      commit('setValue', newValue);
    },
    addNotification({ commit }, notification) {
      commit('addNotification', notification);
    },
    goToSection({commit}, {sectionId}) {
      const section = document.getElementById(sectionId);
      const navigators = document.getElementsByClassName('navigator');
      const elem = document.getElementById(`navigator-${sectionId}`);
      for (let i = 0; i < navigators.length; i++) {
        navigators[i].classList.remove('active');
      }
      if (elem) {
        elem.classList.add('active');
      }
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    },
    async addNewUbo({ commit }, ubo) {
      let uboCreateResponse = await API.createNewUbo(ubo);
      commit('addUboObjects', uboCreateResponse);
    },
    async addNewOfficial({commit}, official) {
      let officialCreateResponse = await API.createPerson(official);
      commit('addPersonObject', officialCreateResponse);
      return true;
    },
    async addNewMD({commit}, obj) {
      let managindDirrectorResponse = await API.createMD(obj);
      commit('addMDObject', managindDirrectorResponse);
      return true;
    },
    async addNewShareHolder({commit}, obj) {
      let shareholderResponse = await API.createShareholder(obj);
      commit('addShareholderObject', shareholderResponse);
      return true
    },
    async addNewBankDocument({state, commit}, {documentType, bank_name}) {
      const fileResponse = await API.createFileSection({documentType, bank_name, company_id: state.companyData._id});
      commit('setValue', {key: 'kyc_files', value: [fileResponse.file, ...state.kyc_files]});
      return true
    },
    async addAccountNumber({commit}, {id}) {
      let accountNumberResponse = await API.createAccountNumber(id);
      commit('addAccountNumberMutations', accountNumberResponse.accountNumber);
      commit('addTransactionProfileMutations', accountNumberResponse.transactionalProfile);
    },
    loadcolapsedSections({ commit }) {
      const colapsedSections = localStorage.getItem('colapsedSections');
      if (colapsedSections) {
        commit('setValue', {key: 'colapsedSections', value: JSON.parse(colapsedSections)});
      }
    },
    saveColapsedSections({ state }, _) {
      localStorage.setItem('colapsedSections', JSON.stringify(state.colapsedSections));
    },
    toggleSection({state, dispatch}, {id}) {
      const section = document.getElementById('collapse_' + id);
      console.log('toggleSection', id, section)
      let isOpenSection = state.colapsedSections[id] != undefined ? state.colapsedSections[id] : true;

      state.colapsedSections[id] = !isOpenSection;
      isOpenSection = !isOpenSection;
      dispatch('saveColapsedSections')
      if (isOpenSection) {
        section.style.maxHeight = section.scrollHeight + "px";
        section.style.overflowY = "hidden"; 
        setTimeout(() => {
        if (isOpenSection) {
            section.style.maxHeight = "none";
            section.style.overflowY = "visible";
        }
        }, 300); 
      } else {
        section.style.maxHeight = section.scrollHeight + "px"; 
        section.style.overflowY = "hidden";
        requestAnimationFrame(() => {
          section.style.maxHeight = "0"; 
        });
      }
    },
    async loadEnv({state, commit}, {id}) {
      await API.getNotificationCount({view: 'forConfirmation', id: id});
    },
    async saveFile({state, commit}) {
      
    },
    async saveKycValues({state, commit}) {
      // TODO validate
      commit('setValue', {key: 'savingData', value: true});
      let updatesMade = false;
      for(let md of state.kyc_mds) {
        let fieldsToSend = {};
        for (let field of mdFields) {
          let newValue = md[field]?.new_value?.trim ? md[field].new_value.trim() : md[field].new_value;

          if (newValue !== md[field].value && newValue != undefined && newValue !== null) {
            fieldsToSend[field] = newValue;
          }
        }
        if (Object.keys(fieldsToSend).length > 0) {
          const response = await API.updateMD(md._id, fieldsToSend);
          updatesMade = true;
          commit('updateManagingDirrectorById', {id: md._id, updates: response.md, full: true});
        }
      }
      for (let person of state.kyc_persons) {
        let fieldsToSend = {};
        for (let key of personFields) {
          let newValue = person[key]?.new_value?.trim ? person[key].new_value.trim() : person[key].new_value;

          if (newValue !== person[key].value  && newValue != undefined && newValue !== null) {
            fieldsToSend[key] = newValue;
          }
        }
        if (Object.keys(fieldsToSend).length > 0) {
          const response = await API.updatePerson(person._id, fieldsToSend);
          updatesMade = true;
          commit('updatePersonById', {id: person._id, updates: response.person, full: true});
        }
      }
      for (let entity of state.kyc_entities) {
        let fieldsToSend = {};
        for (let key of entityFields) {
          let newValue = entity[key]?.new_value?.trim ? entity[key].new_value.trim() : entity[key].new_value;

          if (
              newValue != undefined &&
              newValue !== entity[key].value && 
              ( 
                newValue.toString().length > 0
              )
            ) {
              fieldsToSend[key] = newValue;
          }
        }
        if (Object.keys(fieldsToSend).length > 0) {
          const response = await API.updateEntity(entity._id, fieldsToSend);
          updatesMade = true;
          commit('updateEntityById', {id: entity._id, updates: response.entity, full: true});
        }
      }
      for (let file of state.kyc_files) {
        const ObjectToSend = {}
        let attachedFile = null
        const newFIleUploaded = file.new_file;
        if (newFIleUploaded) {
          attachedFile = file.file
        }
        for (let field of metaFieldsFile) {
          if (file['new_' + field] && file['new_' + field].trim() !== file[field]) {
            ObjectToSend[field] = file['new_' + field]
          }
        }
        for (let field of commentsPerson) {
          if (new_comments(file, field)) {
            ObjectToSend[field] = JSON.stringify(file['new_' + field])
          }
        }
        if (attachedFile || Object.keys(ObjectToSend).length > 0) {
          const response = await API.updateFile(file.id, attachedFile, ObjectToSend);
          updatesMade = true;
          commit('updateFileById', {id: file.id, updates: response.file, full: true});
        }
      }
      for (let accountNumber of state.kyc_accountNumbers) {
        let fields = [
          'account_number',
        ]
        let fieldsToSend = {};
        for (let field of fields) {
          let newValue = accountNumber[field]?.new_value?.trim ? accountNumber[field].new_value.trim() : accountNumber[field].new_value;
          if (newValue !== accountNumber[field].value && newValue != undefined && newValue !== null) {
            fieldsToSend[field] = newValue;
          }
        }
        if (Object.keys(fieldsToSend).length > 0) {
          const response = await API.updateAccountNumber(accountNumber._id, fieldsToSend);
          updatesMade = true;
          commit('updateAccountNumberById', {id: accountNumber._id, updates: response.accountNumber, full: true});
        }
      }
      for (let transactionProfile of state.kyc_transactionalProfile) {
        let fieldsToSend = {};
        for (let field of fieldsTransaction) {
          let newValue = transactionProfile[field]?.new_value?.trim ? transactionProfile[field].new_value.trim() : transactionProfile[field].new_value;
          if (newValue !== transactionProfile[field].value && newValue != undefined && newValue !== null) {
            fieldsToSend[field] = newValue;
          }
        }
        for (let field of commentsTransaction) {
          let result = new_comments(transactionProfile, field, 'new');
          if (result) {
            fieldsToSend[field] = JSON.stringify(transactionProfile[field].new_value);
          }
        }
        if (Object.keys(fieldsToSend).length > 0) {
          const response = await API.updateTransactionProfile(transactionProfile._id, fieldsToSend);
          updatesMade = true;
          commit('updateTransactionProfileById', {id: transactionProfile._id, updates: JSON.parse(JSON.stringify(response.transactionProfile)), full: true});
        }
      }
      for (let shareholder of state.kyc_shareholders) {
        let fields = [
          'percentage_held',
          'shareholder_type',
        ]
        let fieldsToSend = {};
        for (let field of fields) {
          if (shareholder[field].new_value !== shareholder[field].value && shareholder[field].new_value) {
            fieldsToSend[field] = shareholder[field].new_value;
          }
        }
        if (Object.keys(fieldsToSend).length > 0) {
          const response = await API.updateShareholder(shareholder._id, fieldsToSend);
          updatesMade = true;
          commit('updateShareHolderById', {id: shareholder._id, updates: response.shareholder, full: true});
        }
      }
      {
        let fieldsToSend = {};
        console.log('state.companyData', state.companyData)

        for (let key in state.companyData) {
          if (['_id', 'company_type'].includes(key)) {
            continue
          }
          let newValue = state.companyData[key]?.new_value?.trim ? state.companyData[key].new_value.trim() : state.companyData[key].new_value;
          
          if (newValue !== state.companyData[key].value && newValue != undefined && newValue !== null) {
            fieldsToSend[key] = newValue;
          }

        }
        console.log('fieldsToSend', fieldsToSend)
        if (Object.keys(fieldsToSend).length > 0) {
          const response = await API.updateKycReviewInfo(state.companyData._id, fieldsToSend);
          updatesMade = true;
          console.log('response', response)
          commit('updateKycReviewInfo', {updates: response.companyData, full: true});
        }
      }
      if (state.listingServices?.new_value && state.listingServices.new_value !== state.listingServices.value) {
        const response = await API.updateListingServices({ value: state.listingServices.new_value, company_id: state.companyData._id });
        updatesMade = true;
        commit('resetListingServices', state.listingServices.new_value);
      }
      
      if (updatesMade) {
        commit('addNotification', {type: 'success', text: 'Data saved successfully'});
      }
      commit('setValue', {key: 'savingData', value: false});
      this.dispatch('reloadNotification');
    },
    async reloadNotification ({state, commit}) {
      const info = await API.getNotificationList({page: 1, view: 'forConfirmation', id: state.companyData._id});
      commit('setValue', {key: 'confirmationNeeded', value: info.notifications});
      commit('setValue', {key: 'notificationsCount', value: info.notifications.length});
    },
    async deleteUbo({state, commit}, {ubo_id}) {
      const ubo = state.kyc_ubos.find(ubo => ubo._id === ubo_id);
      if (ubo) {
        const result = await API.deleteObject(ubo_id, 'ubo', 'UBO');
        if (result) {
          commit('setValue', {key: 'kyc_ubos', value: state.kyc_ubos.filter(ubo => ubo._id !== ubo_id)});
        }
      }
    },
    async deletePerson({state, commit}, {person_id}) {
      const person = state.kyc_persons.find(person => person._id === person_id);
      if (person) {
        const result = await API.deleteObject(person_id, 'person', 'Individual');
        if (result) {
          commit('setValue', {key: 'kyc_persons', value: state.kyc_persons.filter(person => person._id !== person_id)});
        }
      }
    },

    // getPersonRelatedElements({state}, {id}){
    //   let sourceElement = state.proposedChanges.find(element => element.person === id);
    //   return sourceElement;
    // },

    // getRelatedElements({state, dispatch}, {id}){
    //   let sourceElement = state.proposedChanges.find(element => element._id === id);
    //   if (!sourceElement) {
    //     return null;
    //   }
    //   if (sourceElement.type === 'kyc_file') {
    //     return state.proposedChanges.filter(proposition => proposition.kyc_file === sourceElement._id);
    //   }
    //   if (sourceElement.type === 'person') {
    //     return dispatch('getPersonRelatedElements', {id: sourceElement._id});
    //   }

    // },
    async deleteShareHolder({state, commit}, {shareholder_id}) {
      const shareholder = state.kyc_shareholders.find(shareholder => shareholder._id === shareholder_id);
      if (shareholder) {
        const result = await API.deleteObject(shareholder_id, 'share_holder_related', 'Shareholder');
        if (result) {
          commit('setValue', {key: 'kyc_shareholders', value: state.kyc_shareholders.filter(shareholder => shareholder._id !== shareholder_id)});
        }
      }
    },
    async deleteTransactionProfile({state, commit}, {transactionProfile_id}) {
      const transactionProfile = state.kyc_transactionalProfile.find(transactionProfile => transactionProfile._id === transactionProfile_id);
      if (transactionProfile) {
        const result = await API.deleteObject(transactionProfile_id, 'transaction_profile', 'Transaction Profile');
        if (result) {
          commit('setValue', {key: 'kyc_transactionalProfile', value: state.kyc_transactionalProfile.filter(transactionProfile => transactionProfile._id !== transactionProfile_id)});
        }
      }
    },
    async deleteManagingDirector({state, commit}, {md_id}) {
      const md = state.kyc_mds.find(md => md._id === md_id);
      if (md) {
        const result = await API.deleteObject(md_id, 'mbd_related', 'Managing Director');
        if (result) {
          commit('setValue', {key: 'kyc_mds', value: state.kyc_mds.filter(md => md._id !== md_id)});
        }
      }
    },
    async deleteKycSection({state, commit}, {company_id}) {
      const result = await API.deleteObject(company_id, 'kyc_review', 'KYC Review');
      if (result) {
        commit('setValue', {key: 'companyData', value: null});
      } 
    },

    checkDueDiligenceElements({state, commit}) {
      state.dueDiligenceCheck = true
    
      // Clear all errors in due diligence elements
      for (let element of state.dueDiligenceElements) {
        for (let field in element) {
          if (element[field]?.error !== undefined) {
            element[field].error = '';
          }
        }
      }
    
      // // Clear all errors in due diligence record
      // for (let field in state.dueDiligenceRecord) {
      //   if (state.dueDiligenceRecord[field]?.error !== undefined) {
      //     state.dueDiligenceRecord[field].error = '';
      //   }
      // }

      


      let requiredDueDiligenceFields = [
        'filler_full_name',
        'position',
        'date_when_signed',
        'us_applicant',
        'us_applicant_connect',
        'us_applicant_tag_related',
        'peps_present',
        'interesting_past',
        'peps_present_details',
        'interesting_past_details',
        'internal_aml_policy',
        'compliance_officer_present',
        'has_customer_kyc',
        'customer_pep_conducted',
        'customer_transaction_monitoring',
        'suspicious_activity_reported',
        'compliance_officer_email',
        'compliance_officer_name',
        'compliance_officer_phone',
      ]

      let ignore_fields = {
        '_id' : '-',
        'type' : '-',
        'due_diligense_id': '-',
        'status': '-'
      }
      let personFields = {
        'full_name': '-',
        'date_of_birth': '-',
        'residential_address': '-',
        'identity_document': '-',
        'identity_document_number': '-',
        'date_of_issue': '-',
        'date_of_expiry': '-',
        'issuing_authority': '-',
        'issuing_state': '-',
        'place_of_birth': '-',
        'politically_exposed_person': '-',
      }
      let company_fields = {
        'trading_name': '-', 
        'business_address': '-',
      }
      let otherCorporateNonMainCompany = {
        'tax_id': '-',
        'contact_person_name': '-',
        'website_urls': '-',
        'license_issuing_authority': '-',
        'license_type': '-',
        'license_number': '-',
        'license_date_of_issue': '-',
        'license_date_of_expiry': '-',
        'targeted_countries': '-',
        'registration_date': '-',
        'license_expiry_date': '-',
      }
      let companyRelatedFields = {
        'company_name': '-',
        'registration_number': '-',
        'registration_country': '-',
        'registered_address': '-',
      }

      let dueDiligenceOptinalFieldsByType = {
        'company': {
          ...ignore_fields,
          ...company_fields,
          ...personFields,
          'amount_of_shares_holding': '-',
          'is_relevant': '-',

        },
        'corporate_person': {
          ...ignore_fields,
          ...company_fields,
          ...personFields,
          ...otherCorporateNonMainCompany,
          'amount_of_shares_holding': '-',
        }, 
        'corporate_shareholder': {
          ...ignore_fields,
          ...company_fields,
          ...personFields,
          ...otherCorporateNonMainCompany,
        }, 
        'shareholder': {
          ...ignore_fields,
          ...company_fields,
          ...otherCorporateNonMainCompany,
          ...companyRelatedFields,
          'is_relevant': '-',
        }, 
        'director': {
          ...ignore_fields,
          ...company_fields,
          ...otherCorporateNonMainCompany,
          ...companyRelatedFields,
          'amount_of_shares_holding': '-',
          'is_relevant': '-',

        }, 
        'beneficiary': {
          ...ignore_fields,
          ...company_fields,
          ...otherCorporateNonMainCompany,
          ...companyRelatedFields,
          'is_relevant': '-',

        },
      }
      let missing_fields = false;
      for (let element of state.dueDiligenceElements) {
        let optinalFields = dueDiligenceOptinalFieldsByType[element.type.value];
        if (!optinalFields.is_relevant) {
          let relevant_field = element.is_relevant;
          let value = relevant_field.new_value || relevant_field.new_value;
          
          if (!value) {
            missing_fields = true;
            relevant_field.error = 'This field is required';
            continue;
          }
          if (value === 'NO') {
            continue;
          } 
        }

        if(!optinalFields){
          console.log('No optinal fields for type', element.type)
          continue
        }
        for (let fields in element) {
          try {
            if (optinalFields[fields] === '-') {
              continue;
            }
            let field = element[fields];
            if (
              (!field.value && !field.new_value) ||
              (field.value && field.new_value === '')
            ) {
              missing_fields = true;
              field.error = 'This field is required';
            }
          } catch(error) {
            console.error('Error checking field', fields, error);
          }
          
        }
      }
      for (let field of requiredDueDiligenceFields) {
        let element = state.dueDiligenceRecord[field];
      
        if (field === 'interesting_past_details' || field === 'peps_present_details') {
          let elementMap = {
            interesting_past_details: 'interesting_past',
            peps_present_details: 'peps_present'
          }
          let fieldToCheck = elementMap[field];
          let currentValue = 'NO';
          if (state.dueDiligenceRecord[fieldToCheck].new_value === 'YES'){ 
            currentValue = 'YES';
          }
          if (!state.dueDiligenceRecord[fieldToCheck].new_value && state.dueDiligenceRecord[fieldToCheck].value === 'YES') {
            currentValue = 'YES';
          }
          if (currentValue === 'YES') {
            let commentPresent = commentHasContentStructure(state.dueDiligenceRecord[field])
            if (!commentPresent) {
              missing_fields = true;
              element.error = 'This field is required';
            }
          }
        } else if (['compliance_officer_email',
          'compliance_officer_name',
          'compliance_officer_phone'].includes(field)) {
            let currentValue = 'NO';
            if (state.dueDiligenceRecord['compliance_officer_present'].new_value === 'YES'){ 
              currentValue = 'YES';
            }
            if (!state.dueDiligenceRecord['compliance_officer_present'].new_value && state.dueDiligenceRecord['compliance_officer_present'].value === 'YES') {
              currentValue = 'YES';
            }
            if (currentValue === 'YES') {
              if (!element || (!element.value && !element.new_value)) {
                missing_fields = true;
                element.error = 'This field is required';
              }
            }
        } else if (!element || (!element.value && !element.new_value)) {
          missing_fields = true;
          element.error = 'This field is required';
        }
      }
      return missing_fields
    }
  },
  modules: {}
})
